var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-rfid"},[_c('tokens-manager',{attrs:{"customer-id":_vm.customer.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }